// extracted by css-extract-rspack-plugin
export default {"LabelWrapper":"Label-module__LabelWrapper__GobDX","Label":"Label-module__Label__WyIUk"};